import React from 'react'
import styled, {injectGlobal} from 'styled-components'
import load from 'little-loader'


const captchaPromise = new Promise((res, rej) => {
  window.onLoadCaptchResolve = res
})

export const waitCaptcha = ((captchaCallback,captchaRef) => {
  load("https://www.google.com/recaptcha/api.js?onload=onLoadCaptchResolve&render=explicit")
  return captchaPromise.then(() => new Promise(res => {
    window.grecaptcha.ready(function () {
      window.grecaptcha.render(captchaRef.current, {
        "sitekey": "6LdLB_8lAAAAAEw76Pnd9NaPpYOhGl8mxqB2TRVj",
        "size": "invisible",
        callback: captchaCallback
      });
      res()
    });
  }))
})

export const executeCaptcha = (values) => new Promise((res, rej) => {
  window.grecaptcha.reset()
  window.grecaptcha.execute()
  const iframe = document.querySelector("iframe[title='recaptcha challenge']")
  if (!iframe || !iframe.parentNode || iframe.parentNode.parentNode) {
    return;
  }
  const container = iframe.parentNode.parentNode;
  const observer = new MutationObserver(mutations => {
    if (container && container.style.visibility === 'hidden') {
      if (!window.grecaptcha.getResponse()) {
        rej([values, {}])
      }
      observer.disconnect()
    }
  });
  observer.observe(container, {attributes: true, attributeFilter: ['style']});
})

injectGlobal`
.grecaptcha-badge { visibility: hidden; }
`

export const RecaptchaBrandingText = styled.div`
  color: rgba(0,0,0,0.4);
  font-size: 12px;
  margin-right: auto;
  padding-right: 1rem;
  align-self: center;
  a {
    color: inherit;
  }
`



// WEBPACK FOOTER //
// ./src/javascripts/checkout/CaptchaUtils.jsx